import Api from '@/api/api';
import * as Helpers from "@/helpers";
import moment from 'moment';

const state = {
  headers: [
    { text: 'ID', value: 'id' },
    { text: 'Nome Evento', value: 'nome_evento' },
    { text: 'Periodo Inicial Evento', value: 'data_inicio' },
    { text: 'Periodo Final Evento', value: 'data_fim' },
    { text: 'Venda Prevista', value: 'venda_prevista' },
    { text: 'Venda Realizadas', value: 'venda_realizada' },
    { text: 'Porcentagem', value: 'porcentagem', style: { width: '90px' }},
    { text: 'Evento Ativo', value: 'ativo', style: { width: '90px' }},
    { text: 'Status', value: 'status' },
    { text: '', value: 'acoes' }
  ],
  items: [],
  // Área Novo Evento
  dialog_novo_evento: false,
  form_novo_evento: {
    id: '',
    nome_evento: '',
    data_inicial: '',
    data_final: '',
    data_inicio_compra: ''
  },
  // Área do Grafico & Tabela de seleção
  dialog_grafico_tabela: false,
  dados_grafico_tabela: {},
  filtros_grafico_tabela: {
    anos: [],
    periodos: ['01','02','03','04','05','06','07','08','09','10','11','12'],
    systock_filtros: {
      grupos: [],
      filiais: [],
      fornecedores: [],
      segmentos: [],
      compradores: [],
      status_produto: [],
      histograma: []
    },
    qtde_faturamento: false,
    itens_nao_vendido: false,
  },
  headers_tabela: [
    { text: 'Categoria', value: 'descricao_familia_produto' },
    { text: 'Fornecedor', value: 'razao_social' },
    { text: 'Id Produto', value: 'idproduto' },
    { text: 'Descrição Produto', value: 'descricao_produto' },
    { text: 'UM', value: 'idunidade_medida' },
    { text: 'Estoque atual', value: 'estoque', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Media de vendas ult. 3 meses', value: 'media_tres_meses' },
    { text: 'Preço de venda atual', value: 'preco_venda_evento_estatico', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Mark-up evento (%)', value: 'markup_evento_estatico' },
    { text: 'Projeção de Venda (qtd)', value: 'quantidade_evento_estatico' },
    { text: 'Projeção de Venda (R$)', value: 'faturamento_evento_estatico' },
    { text: 'Preço de custo Atual', value: 'preco_custo_evento', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Acrescimo (%)', value: 'acrescimo' },
    { text: 'Desconto (%)', value: 'desconto' },
    { text: 'Preço de venda evento', value: 'preco_venda_evento' },
    { text: 'Mark-up evento (%)', value: 'markup_evento' },
    { text: 'Projeção de Venda (qtd)', value: 'quantidade_evento' },
    { text: 'Projeção de Venda (R$)', value: 'faturamento_evento' },
  ],
  dados_tabela: [],
  selecionados_dados_tabela: [],
  // Área Combinar
  dialog_combinar: false,
  dados_combinar: [],
  selecionado_combinar: [],
  headers_combinar: [
    { text: 'Categoria', value: 'descricao_familia_produto' },
    { text: 'Fornecedor', value: 'razao_social' },
    { text: 'Id Produto', value: 'idproduto' },
    { text: 'Descrição Produto', value: 'descricao_produto' },
    { text: 'UM', value: 'idunidade_medida' },
    { text: 'Estoque atual', value: 'estoque', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Media de vendas ult. 3 meses', value: 'media_tres_meses' },
    { text: 'Preço de venda evento', value: 'preco_venda_evento', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Mark-up evento (%)', value: 'markup_evento' },
    { text: 'Projeção de Venda (qtd)', value: 'quantidade_evento' },
    { text: 'Projeção de Venda (R$)', value: 'faturamento_evento' },
  ],
  // Área dos produtos na lista de evento
  dialog_lista_evento: false,
  itens_evento: [],
  headers_lista_evento: [
    { text: 'Categoria', value: 'descricao_familia_produto' },
    { text: 'Fornecedor', value: 'razao_social' },
    { text: 'Id Produto', value: 'idproduto' },
    { text: 'Descrição Produto', value: 'descricao_produto' },
    { text: 'UM', value: 'idunidade_medida' },
    { text: 'Leadtime', value: 'tempo_medio_ressuprimento', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Data Inicio Compra', value: 'inicio_compra_produto' },
    { text: 'Previsão Chegada', value: 'previsao_chegada' },
    { text: 'Chega antes do inicio', value: 'chegada_antes_evento' },
    { text: 'Estoque atual', value: 'estoque', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Media de vendas ult. 3 meses', value: 'media_tres_meses' },
    { text: 'Preço de custo Atual', value: 'preco_custo_evento', style: { borderLeft: '1px solid #cecece', padding: '0px 10px' } },
    { text: 'Acrescimo (%)', value: 'acrescimo' },
    { text: 'Desconto (%)', value: 'desconto' },
    { text: 'Preço de venda evento', value: 'preco_venda_evento' },
    { text: 'Mark-up evento (%)', value: 'markup_evento' },
    { text: 'Projeção de Venda (qtd)', value: 'quantidade_evento' },
    { text: 'Projeção de Venda (R$)', value: 'faturamento_evento' },
    { text: '', value: 'acoes' },
  ],
  // Área da Configuração Geral
  dialog_configuracao_geral: false,
  dialog_configuracao_individual: false,
}

const getters = {
  GET_HEADERS: (state) => state.headers,
  GET_ITEMS: (state) => state.items,
  // Área Novo Evento
  GET_DIALOG_NOVO_EVENTO: (state) => state.dialog_novo_evento,
  GET_FORM_NOVO_EVENTO: (state) => state.form_novo_evento,
  // Área do Grafico & Tabela de seleção
  GET_DIALOG_GRAFICO_TABELA: (state) => state.dialog_grafico_tabela,
  GET_DADOS_GRAFICO_TABELA: (state) => state.dados_grafico_tabela,
  GET_FILTROS_GRAFICO_TABELA: (state) => state.filtros_grafico_tabela,
  GET_HEADERS_TABELA: (state) => state.headers_tabela,
  GET_DADOS_TABELA: (state) => state.dados_tabela,
  GET_SELECIONADOS_DADOS_TABELA: (state) => state.selecionados_dados_tabela,
  // Área Combinar
  GET_DIALOG_COMBINAR: (state) => state.dialog_combinar,
  GET_DADOS_COMBINAR: (state) => state.dados_combinar,
  GET_SELECIONADO_COMBINAR: (state) => state.dados_combinar,
  GET_HEADERS_COMBINAR: (state) => state.headers_combinar,
  // Área dos produtos na lista de evento
  GET_DIALOG_LISTA_EVENTO: (state) => state.dialog_lista_evento,
  GET_ITENS_EVENTO: (state) => state.itens_evento,
  GET_HEADERS_LISTA_EVENTO: (state) => state.headers_lista_evento,
  // Área da Parametrização
  GET_DIALOG_CONFIGURACAO_GERAL:(state) => state.dialog_configuracao_geral,
  GET_DIALOG_CONFIGURACAO_INDIVIDUAL:(state) => state.dialog_configuracao_individual,
}

const mutations = {
  SET_ITEMS: (state, payload) => state.items = payload,
  // Área Novo Evento
  SET_DIALOG_NOVO_EVENTO: (state, payload) => state.dialog_novo_evento = payload,
  SET_FORM_NOVO_EVENTO: (state, payload) => state.form_novo_evento = payload,
  // Área do Grafico & Tabela de seleção
  SET_DIALOG_GRAFICO_TABELA: (state, payload) => state.dialog_grafico_tabela = payload,
  SET_DADOS_GRAFICO_TABELA: (state, payload) => state.dados_grafico_tabela = payload,
  SET_FILTROS_GRAFICO_TABELA(state, payload) {
    state.filtros_grafico_tabela = {
      ...state.filtros_grafico_tabela,
      ...payload
    }
  },
  SET_DADOS_TABELA(state, payload) {
    payload.map(m => {
      m.old = Object.assign({}, m);
      return m;
    });
    state.dados_tabela = payload
  },
  SET_SELECIONADOS_DADOS_TABELA: (state, payload) => state.selecionados_dados_tabela = payload,
  // Área Combinar
  SET_DIALOG_COMBINAR: (state, payload) => state.dialog_combinar = payload,
  SET_DADOS_COMBINAR: (state, payload) => state.dados_combinar = payload,
  SET_SELECIONADO_COMBINAR: (state, payload) => state.dados_combinar = payload,
  // Área dos produtos na lista de evento
  SET_DIALOG_LISTA_EVENTO: (state, payload) => state.dialog_lista_evento = payload,
  SET_ITENS_EVENTO: (state, payload) => state.itens_evento = payload,
  // Área da Parametrização
  SET_DIALOG_CONFIGURACAO_GERAL:(state, payload) => state.dialog_configuracao_geral = payload,
  SET_DIALOG_CONFIGURACAO_INDIVIDUAL:(state, payload) => state.dialog_configuracao_individual = payload,
}

const actions = {
  setDialogNovoEvento({ commit }, value) {
    commit('SET_DIALOG_NOVO_EVENTO', value)
  },
  setDialogCombinar({ commit }, value) {
    commit('SET_DIALOG_COMBINAR', value);
  },
  setFormNovoEvento({ commit }, value) {
    commit('SET_FORM_NOVO_EVENTO', value)
  },
  setFiltrosGraficoTabela({ commit}, value) {
    commit('SET_FILTROS_GRAFICO_TABELA', value);
  },
  setDialogGraficoTabela({ commit }, value) {
    commit('SET_DIALOG_GRAFICO_TABELA', value)
  },
  setSelecionadosDadosTabela({ commit }, value) {
    commit('SET_SELECIONADOS_DADOS_TABELA', value);
  },
  setDialogListaEvento({ commit }, value) {
    commit('SET_DIALOG_LISTA_EVENTO', value);
  },
  setDadosCombinar({ commit }, value) {
    commit('SET_DADOS_COMBINAR', value);
  },
  setDialogParametrizacao({ commit }, value) {
    commit("SET_DIALOG_PARAMETRIZACAO", value);
  },
  setDialogConfiguracaoGeral({ commit }, value){
    commit("SET_DIALOG_CONFIGURACAO_GERAL", value);
  },
  setDialogConfiguracaoIndividual({ commit }, value) {
    commit("SET_DIALOG_CONFIGURACAO_INDIVIDUAL", value);
  },
  buscarDadoInicial(contexto) {
    Api.post(`eventos-sazonais/analise-periodo`)
    .then(response => {
      const dados = response.data.dados;
      contexto.commit('SET_ITEMS', dados);
    })
    .catch(Helpers.logout);
  },
  buscarDadosGrafico(contexto, idproduto) {
    const params = {
      ...contexto.getters.GET_FILTROS_GRAFICO_TABELA,
      idproduto: idproduto
    }

    Api.post(`eventos-sazonais/analise-periodo/grafico`, params)
      .then(response => contexto.commit("SET_DADOS_GRAFICO_TABELA", response.data))
      .catch(Helpers.logout);
  },
  buscarDadosTabela(contexto) {
    const ids = contexto.getters.GET_ITENS_EVENTO.map(map => map.idproduto);
    const params = {
      ...contexto.getters.GET_FILTROS_GRAFICO_TABELA,
      remover_idsproduto: ids
    }

    Api.post(`eventos-sazonais/analise-periodo/tabela`, params)
      .then(response => {
        const dados = response.data.dados;
        let menor_data = null;

        if (dados.length > 0) {
          dados.map(map => {
            const ressuprimento = Number(map.tempo_medio_ressuprimento) + 1;
            const inicio_compra_produto = moment(contexto.getters.GET_FORM_NOVO_EVENTO.data_inicial).subtract(ressuprimento, 'days');
            const previsao_chegada = moment(contexto.getters.GET_FORM_NOVO_EVENTO.data_inicial).subtract(1, 'days');

            map.inicio_compra_produto = inicio_compra_produto.format('YYYY-MM-DD');
            map.previsao_chegada = previsao_chegada.format('YYYY-MM-DD');
            map.chegada_antes_evento = inicio_compra_produto.isBefore(previsao_chegada);

            return map;
          });

          menor_data = dados[0].inicio_compra_produto;

          for (let i = 1; i < dados.length; i++) {
            const data_atual = new Date(dados[i].data);
            if (data_atual < menor_data) menor_data = data_atual;
          }
        }


        contexto.commit('SET_FORM_NOVO_EVENTO', { ...contexto.getters.GET_FORM_NOVO_EVENTO, data_inicio_compra: menor_data });
        contexto.commit("SET_DADOS_TABELA", dados);
      })
      .catch(Helpers.logout);
  },
  adicionarProdutosNaLista({ commit, getters }) {
    const itens_remover = getters.GET_SELECIONADOS_DADOS_TABELA.map(m => m.idproduto);
    const novo_itens_tabela = getters.GET_DADOS_TABELA.filter(f => !itens_remover.includes(f.idproduto));
    const novo_itens_evento = [...getters.GET_ITENS_EVENTO, ...getters.GET_SELECIONADOS_DADOS_TABELA];

    commit("SET_DADOS_TABELA", novo_itens_tabela);
    commit("SET_ITENS_EVENTO", novo_itens_evento);
    commit("SET_SELECIONADOS_DADOS_TABELA", []);
  },
  combinarAdicionarItensCarrinho(contexto, totalizador) {
    contexto.getters.GET_SELECIONADOS_DADOS_TABELA.forEach(item => contexto.state.dados_tabela.splice(item.index_of, 1));
    contexto.commit("SET_ITENS_EVENTO", [...contexto.getters.GET_ITENS_EVENTO, totalizador]);
    contexto.commit("SET_SELECIONADOS_DADOS_TABELA", []);
    contexto.commit("SET_DADOS_COMBINAR", []);
    contexto.commit("SET_DIALOG_COMBINAR", false);
  },
  removerItemDoEvento(contexto, item) {
    const novo_itens_evento = contexto.getters.GET_ITENS_EVENTO.filter(f => f.idproduto != item.idproduto);
    contexto.commit("SET_ITENS_EVENTO", novo_itens_evento);
    contexto.commit('SET_DADOS_TABELA', [...contexto.getters.GET_DADOS_TABELA, item]);
  },
  verificarDataDeCompra(contexto, data) {
    const novo_itens_evento = contexto.getters.GET_ITENS_EVENTO.map(map => {
      map.inicio_compra_produto = data;
      return map;
    });

    contexto.commit("SET_ITENS_EVENTO", novo_itens_evento);
  },
  concluirNovoEvento({ commit, getters,dispatch }) {
    const params = {
      evento: getters.GET_FORM_NOVO_EVENTO,
      itens: getters.GET_ITENS_EVENTO
    }

    Api.post(`eventos-sazonais/analise-periodo/concluir-novo-evento`, params)
      .then(() => {
        commit('SET_DIALOG_NOVO_EVENTO', false);
        commit('SET_FORM_NOVO_EVENTO', {
          data_inicial: '',
          data_final: '',
          nome_evento: '',
          data_inicio_compra: ''
        });
        commit('SET_DIALOG_GRAFICO_TABELA', false);
        commit('SET_DADOS_TABELA', [])
        commit('SET_DIALOG_LISTA_EVENTO', false);
        commit('SET_ITENS_EVENTO', []);

        dispatch('buscarDadoInicial');
      })
      .catch(Helpers.logout);
  },
  ativarDesativarEvento(contexto, value) {
    Api.post(`eventos-sazonais/analise-periodo/ativar-desativar-evento`, value)
      .then(() => contexto.dispatch('buscarDadoInicial'))
      .catch(Helpers.logout);
  },
  editarEvendoCriado(contexto, item) {
    contexto.dispatch("setFormNovoEvento", {
      id: item.id,
      nome_evento: item.nome_evento,
      data_inicial: moment(item.data_inicio, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      data_final: moment(item.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      data_inicio_compra: moment(item.data_inicio_compra, 'DD/MM/YYYY').format('YYYY-MM-DD')
    });

    Api.post(`eventos-sazonais/analise-periodo/editar-evento-criado`, { evento: item})
      .then(response => {
        const dados = response.data.dados_evento;

        dados.map(map => {
          map.previsao_chegada = moment(map.previsao_chegada, 'DD/MM/YYYY');
          return map;
      });

        contexto.commit("SET_ITENS_EVENTO", dados);
        contexto.dispatch("setDialogNovoEvento", true);
      })
      .catch(Helpers.logout);
  },
  aplicarCongelamento(contexto, params) {
    Api.post(`eventos-sazonais/parametrizacao/configuracao/aplicar-congelamento`, params)
      .catch(Helpers.logout);
  }
}

export default { namespaced: true, state, getters, mutations, actions }
